<template>
<v-dialog v-model="dialog" max-width="500px">
	<v-card class="elevation-12">
		<v-toolbar
			color="primary"
			dark
			flat>
			<v-toolbar-title>{{ operation }} Group</v-toolbar-title>
		</v-toolbar>
		<v-card-text>
      <v-form
        ref="form"
        v-model="formValid"
        lazy-validation>
        <v-row>
          <v-col cols="12" md="12">
            <v-text-field
              autofocus
              prepend-icon="mdi-book"
              label="Title"
              v-model="item.title"
              placeholder="Ex. Visual Graphics Design NC III"
              :rules="[rules.required]"
              autocomplete="off"/>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" md="6">
            <DatePicker :value="item.startDate"
              label="Start Date"
              @change="(value) => { item.startDate = value }">
            </DatePicker>
          </v-col>
          <v-col cols="12" md="6">
            <DatePicker :value="item.endDate"
              label="End Date"
              @change="(value) => { item.endDate = value }">
            </DatePicker>
          </v-col>
        </v-row>
        
      </v-form>
		</v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        @click="dialog = false">
        Close
      </v-btn>
      <v-btn v-if="(operation == FORM_STATUS.CREATE)"
        @click="resetFields()">
        Reset
      </v-btn>
      <v-btn 
        color="primary"
        @click="submit">
        {{ operation }}
      </v-btn>
    </v-card-actions>
	</v-card>
</v-dialog>
</template>

<script>
import { FORM_STATUS } from '../../../services/constants'
import Api from '../../../services/api'
import Notify from '../../../services/notify'
import FormRulesMixin from '../../../mixins/form-rules.mixin'
import DatePicker from '../../main/form/DatePicker'

export default {
  name: 'CourseGroupForm',
  components: { DatePicker },
  mixins: [ FormRulesMixin ],
  data() {
    return {
      FORM_STATUS,
      dialog: false,
      loading: false,
      operation: null,
      formValid: true,
      item: {},
      defaultItem: {
        courseId: null,
        title: null,
        startDate: null,
        endDate: null,
      },
      teachers: [],
    }
  },
  mounted() {

  },
  methods: {
		resetFields() {
			this.item = Object.assign({}, this.defaultItem);
    },

    create(courseId) {
      this.operation = FORM_STATUS.CREATE;
      this.dialog = true;
      this.resetFields();
      this.item.courseId = courseId;
      console.log(this.item);
    },

    update(courseGroupId) {
      this.operation = FORM_STATUS.UPDATE;
      this.dialog = true;
      this.loading = true;
      Api.course.group.get(courseGroupId)
        .then((response) => {
          this.item = response.data;
          this.loading = false;
          console.log(this.item);
        });
    },

    delete(courseGroupId) {
      this.operation = FORM_STATUS.DELETE;
      Notify.confirm('Delete group?', "Action can't be undone.")
        .then(() => {
          this.loading = true;
          Api.course.group.delete(courseGroupId)
            .then(() => {
              this.dialog = false;
              Notify.success.itemDeleted();
              this.$emit('group-deleted');
            })
            .catch(() => { Notify.toast("Members must be removed first before deletion", "error"); })
            .finally(() => { this.loading = false });
        });
    },

    submit() {
			if(!this.$refs.form.validate()) {
        Notify.error.checkData();
        return;
      }

      if(this.operation == FORM_STATUS.CREATE) {
        this.loading = true;
        Api.course.group
          .create(this.item)
          .then(() => {

            this.dialog = false;
            this.$emit('group-created');
            this.dialog = false;
            Notify.success.itemCreated();
            this.$emit('course-created');
          })
          .catch(() => { Notify.error.createFailed() })
          .finally(() => { this.loading = false });
      } 
      else if(this.operation == FORM_STATUS.UPDATE) {
        this.loading = true;
        Api.course.group.update(this.item)
          .then(() => {
            this.dialog = false;
            Notify.success.itemUpdated();
            this.$emit('group-updated');
          })
          .catch(() => { Notify.error.updateFailed() })
          .finally(() => { this.loading = false });
      }
    },
  },
}
</script>